import { Box, Icon, Text, styled } from '@qcx/ui';
import { Card } from '../../../components/Card';
import { Link } from '../../../components/Link';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { useCallback, useReducer, useState } from 'react';

interface FilterWidgetItemProps {
  name: string;
  slug: string;
  value: string;
}
export interface FilterWidgetProps {
  items?: FilterWidgetItemProps[];
  kind: 'institutos' | 'regioes' | 'especiais' | undefined;
}

const defaultItems = [
  {
    name: 'Todas',
    slug: '',
    value: ''
  },
  {
    name: 'Especiais',
    slug: '?tipo=especiais',
    value: 'especiais'
  },
  {
    name: 'Região',
    slug: '?tipo=regioes',
    value: 'regioes'
  },
  {
    name: 'Instituto',
    slug: '?tipo=institutos',
    value: 'institutos'
  }
];

export function EditorialsLinks({
  items = defaultItems,
  kind
}: FilterWidgetProps) {
  const [open, hidden] = useReducer(state => !state, false);

  const [selectedOption, setSelectedOption] = useState(kind ?? '');

  const handleOptionClick = useCallback((option: string) => {
    setSelectedOption(option);
  }, []);

  return (
    <Box>
      <Text
        as="div"
        css={{
          textTransform: 'uppercase',
          color: '$textMuted',
          mb: '$2',
          '@lg': { d: 'none' }
        }}
        variant="sm"
        weight="medium"
      >
        Editorias
      </Text>
      <Card css={{ '@lg': { w: 280, h: 260 } }}>
        <Box
          css={{ px: '$4', py: '$3', bb: '1px solid $separatorColor' }}
          onClick={hidden}
        >
          <Box css={{ d: 'flex', justifyContent: 'space-between' }}>
            <Text
              as="div"
              css={{
                textTransform: 'uppercase',
                color: '$textMuted',
                '@lg': { d: 'none' }
              }}
              variant="sm"
              weight="medium"
            >
              {kind ?? 'Todas'}
            </Text>
            <Text
              as="div"
              css={{
                textTransform: 'uppercase',
                color: '$textMuted',
                d: 'none',
                '@lg': { d: 'block' }
              }}
              variant="sm"
              weight="medium"
            >
              Editorias
            </Text>
            <Icon css={{ '@md': { d: 'none' } }} icon={faChevronDown} />
          </Box>
        </Box>
        <Box
          as="ul"
          css={
            open
              ? {
                  divideY: '1px solid $separatorColor',
                  listStyle: 'none'
                }
              : {
                  d: 'none',
                  '@md': {
                    display: 'block',
                    transition: 'all 1s ease',
                    divideY: '1px solid $separatorColor',
                    listStyle: 'none'
                  }
                }
          }
        >
          {items.map(item => (
            <Box key={item.slug} as="li">
              <StyledMenuItem
                selected={selectedOption === item.value}
                to={`${item.slug}`}
                onClick={() => handleOptionClick(item.value)}
              >
                {item.name}
              </StyledMenuItem>
            </Box>
          ))}
        </Box>
      </Card>
    </Box>
  );
}
const StyledMenuItem = styled(Link, {
  display: 'block',
  px: '$4',
  py: '$4',
  color: '$blueDark700 !important',
  textSm: true,
  fontWeight: '$medium',
  bl: '$borderWidths$4 solid transparent',
  '&:hover': {
    bgColor: '$hoverBg',
    borderLeftColor: '$primary'
  },
  variants: {
    selected: {
      true: {
        bgColor: '$hoverBg',
        borderLeftColor: '$primary'
      }
    }
  }
});
